export enum AppFeature {
  Dashboard = 'Dashboard',
  UserDashboard = 'UserDashboard',
  ManageOrders = 'ManageOrders',
  CreateOrder = 'CreateOrder',
  UserManagement = 'UserManagement',
  Reports = 'Reports',
  ProfileSettings = 'ProfileSettings',
  UserProfile = 'UserProfile',
  Target = 'Target',
  RootwisePickingList = 'RootwisePickingList',  
  Monitoring = 'Monitoring',
  CustomerPortalUsers = 'CustomerPortalUsers',
  CustomerSupportView = 'CustomerSupportView'
}